export default () => '/drops?logout=true'
